var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { slot: "pageContent" }, slot: "pageContent" }, [
    _c(
      "div",
      [
        _c(
          "form-accordion",
          {
            attrs: {
              title: _vm.$t("common.security.certificat"),
              isTitleUpperCase: false,
            },
          },
          [
            _c(
              "b-row",
              { staticClass: "d-flex form-group" },
              [
                _c(
                  "b-col",
                  { staticClass: "form-group", attrs: { sm: "6" } },
                  [
                    _c("form-write-group-label-input", {
                      attrs: {
                        isMandatory: "",
                        inputLabel: _vm.$t("common.security.name"),
                        placeholderValue: _vm.$t("common.security.name"),
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form.stateCertificat === 1
              ? _c(
                  "b-button",
                  {
                    staticClass: "back-button btnFilter_2 mr-2 mb-3",
                    on: { click: _vm.updateCertificat },
                  },
                  [
                    _c("i", { staticClass: "fa-light fa-edit" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("common.security.update_certificat")) +
                        "\n       "
                    ),
                  ]
                )
              : _c(
                  "b-button",
                  {
                    staticClass: "back-button btnFilter_2 mr-2 mb-3",
                    on: { click: _vm.cancelCertificat },
                  },
                  [
                    _c("i", { staticClass: "fa-light fa-times" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("common.security.cancel_certificat")) +
                        "\n        "
                    ),
                  ]
                ),
            _vm._v(" "),
            _vm.certificateText !== "" || _vm.form.stateCertificat === 0
              ? _c(
                  "b-row",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center form-group",
                  },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "form-group",
                        attrs: { sm: _vm.certificateText === "" ? 6 : 12 },
                      },
                      [
                        _c("label", { attrs: { for: "certificate-content" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "common.security.certificat_file_content"
                                )
                              ) +
                              "\n            "
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "color-red",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("*")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-form-textarea", {
                          staticStyle: { "max-height": "none" },
                          attrs: {
                            id: "certificate-content",
                            required: "",
                            placeholder: _vm.$t(
                              "common.security.enter_something"
                            ),
                            rows: "6",
                          },
                          on: { input: _vm.processCertificat },
                          model: {
                            value: _vm.certificateText,
                            callback: function ($$v) {
                              _vm.certificateText = $$v
                            },
                            expression: "certificateText",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.certificateText === "" && _vm.form.stateCertificat === 0
                      ? _c(
                          "b-col",
                          {
                            staticClass: "form-group d-flex flex-column",
                            attrs: { sm: "6" },
                          },
                          [
                            _c(
                              "label",
                              { attrs: { for: "certificate-file" } },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("common.security.certificat_file")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                id: "certificate-file",
                                type: "file",
                                accept: ".pem, .crt",
                              },
                              on: { change: _vm.handleFileUploadCertificat },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "d-flex align-items-center form-group" },
              [
                _c(
                  "b-col",
                  { staticClass: "form-group normal-font", attrs: { sm: "6" } },
                  [
                    _c("form-read-group-label-input", {
                      attrs: {
                        inputValue: _vm.getDate(_vm.form.startDate),
                        inputLabel: _vm.$t("common.security.startDate"),
                        placeholderValue: _vm.$t("common.security.startDate"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "form-group normal-font", attrs: { sm: "6" } },
                  [
                    _c("form-read-group-label-input", {
                      attrs: {
                        inputValue: _vm.getDate(_vm.form.endDate),
                        inputLabel: _vm.$t("common.security.endDate"),
                        placeholderValue: _vm.$t("common.security.endDate"),
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "d-flex align-items-center form-group" },
              [
                _c(
                  "b-col",
                  { staticClass: "form-group normal-font", attrs: { sm: "6" } },
                  [
                    _c("form-read-group-label-input", {
                      attrs: {
                        inputValue: _vm.form.deliveredBy,
                        inputLabel: _vm.$t("common.security.deliveredBy"),
                        placeholderValue: _vm.$t("common.security.deliveredBy"),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "form-group normal-font", attrs: { sm: "6" } },
                  [
                    _c("form-read-group-label-input", {
                      attrs: {
                        inputValue: _vm.form.deliveredTo,
                        inputLabel: _vm.$t("common.security.deliveredTo"),
                        placeholderValue: _vm.$t("common.security.deliveredBy"),
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("hr", { staticClass: "mx-auto mb-4" }),
        _vm._v(" "),
        _c(
          "form-accordion",
          {
            attrs: {
              title: _vm.$t("common.security.private_key"),
              isTitleUpperCase: false,
            },
          },
          [
            _vm.form.statePrivateKey === 1
              ? _c(
                  "b-button",
                  {
                    staticClass: "back-button btnFilter_2 mr-2 mb-3",
                    on: { click: _vm.updatePrivateKey },
                  },
                  [
                    _c("i", { staticClass: "fa-light fa-edit" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("common.security.update_privatekey")) +
                        "\n       "
                    ),
                  ]
                )
              : _c(
                  "b-button",
                  {
                    staticClass: "back-button btnFilter_2 mr-2 mb-3",
                    on: { click: _vm.cancelPrivateKey },
                  },
                  [
                    _c("i", { staticClass: "fa-light fa-times" }),
                    _vm._v(
                      "  " +
                        _vm._s(_vm.$t("common.security.cancel_privatekey")) +
                        "\n        "
                    ),
                  ]
                ),
            _vm._v(" "),
            _vm.form.statePrivateKey === 0
              ? _c(
                  "b-row",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center form-group",
                  },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass: "form-group",
                        attrs: { sm: _vm.privateKeyText === "" ? 6 : 12 },
                      },
                      [
                        _c("label", { attrs: { for: "private-key-content" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "common.security.private_key_file_content"
                                )
                              ) +
                              "\n            "
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "color-red",
                              attrs: { "aria-hidden": "true" },
                            },
                            [_vm._v("*")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("b-form-textarea", {
                          staticStyle: { "max-height": "none" },
                          attrs: {
                            id: "private-key-content",
                            required: "",
                            placeholder: _vm.$t(
                              "common.security.enter_something"
                            ),
                            rows: "6",
                          },
                          on: { input: _vm.processPrivateKey },
                          model: {
                            value: _vm.privateKeyText,
                            callback: function ($$v) {
                              _vm.privateKeyText = $$v
                            },
                            expression: "privateKeyText",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.privateKeyText === ""
                      ? _c(
                          "b-col",
                          {
                            staticClass: "form-group d-flex flex-column",
                            attrs: { sm: "6" },
                          },
                          [
                            _c(
                              "label",
                              { attrs: { for: "private-key-file" } },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("common.security.private_key_file")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              attrs: {
                                id: "private-key-file",
                                type: "file",
                                accept: ".pem, .key",
                              },
                              on: { change: _vm.handleFileUploadPrivateKey },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass:
                  "d-flex justify-content-center align-items-center form-group",
              },
              [
                _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                  _c("div", [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("common.security.password"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex" }, [
                      _vm.passwordFieldType === "checkbox"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.password,
                                expression: "form.password",
                              },
                            ],
                            staticClass:
                              "form-control inputAccordionForm inputLogin h-30px",
                            attrs: { autocomplete: "off", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.form.password)
                                ? _vm._i(_vm.form.password, null) > -1
                                : _vm.form.password,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.form.password,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "password",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "password",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "password", $$c)
                                }
                              },
                            },
                          })
                        : _vm.passwordFieldType === "radio"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.password,
                                expression: "form.password",
                              },
                            ],
                            staticClass:
                              "form-control inputAccordionForm inputLogin h-30px",
                            attrs: { autocomplete: "off", type: "radio" },
                            domProps: {
                              checked: _vm._q(_vm.form.password, null),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$set(_vm.form, "password", null)
                              },
                            },
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.password,
                                expression: "form.password",
                              },
                            ],
                            staticClass:
                              "form-control inputAccordionForm inputLogin h-30px",
                            attrs: {
                              autocomplete: "off",
                              type: _vm.passwordFieldType,
                            },
                            domProps: { value: _vm.form.password },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.form,
                                  "password",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "icon icon-password mt-2 pt-1",
                        class: [
                          _vm.isPasswordFieldHidden
                            ? "fa-duotone fa-eye"
                            : "fa-duotone fa-eye-slash",
                        ],
                        on: { click: _vm.toggleVisibility },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }